var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideHomeImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 32.5V14.5C1.5 13.8667 1.642 13.2667 1.926 12.7C2.21 12.1333 2.60133 11.6667 3.1 11.3L15.1 2.3C15.8 1.76667 16.6 1.5 17.5 1.5C18.4 1.5 19.2 1.76667 19.9 2.3L31.9 11.3C32.4 11.6667 32.792 12.1333 33.076 12.7C33.36 13.2667 33.5013 13.8667 33.5 14.5V32.5C33.5 33.6 33.108 34.542 32.324 35.326C31.54 36.11 30.5987 36.5013 29.5 36.5H23.5C22.9333 36.5 22.4587 36.308 22.076 35.924C21.6933 35.54 21.5013 35.0653 21.5 34.5V24.5C21.5 23.9333 21.308 23.4587 20.924 23.076C20.54 22.6933 20.0653 22.5013 19.5 22.5H15.5C14.9333 22.5 14.4587 22.692 14.076 23.076C13.6933 23.46 13.5013 23.9347 13.5 24.5V34.5C13.5 35.0667 13.308 35.542 12.924 35.926C12.54 36.31 12.0653 36.5013 11.5 36.5H5.5C4.4 36.5 3.45867 36.1087 2.676 35.326C1.89333 34.5433 1.50133 33.6013 1.5 32.5Z",
    stroke: "#FCFCFC",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideHomeImg);
export default __webpack_public_path__ + "static/media/side-home-img.49cda7e8cac345f038effe5eb26264e1.svg";
export { ForwardRef as ReactComponent };